import React, { createContext, useContext, useState } from "react";
import al from "./al";
import en from "./en";

const translations = {
  al,
  en,
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check URL query parameter first
    const urlParams = new URLSearchParams(window.location.search);
    const langFromUrl = urlParams.get("lang");
    
    if (langFromUrl && (langFromUrl === "al" || langFromUrl === "en")) {
      localStorage.setItem("appLanguage", langFromUrl);
      return langFromUrl;
    }
    
    // Fallback to localStorage or default
    return localStorage.getItem("appLanguage") || "al";
  });

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("appLanguage", lang);
  };

  const value = {
    language,
    changeLanguage,
    t: (key, params = {}) => {
      let translation = translations[language][key] || key;

      // Replace placeholders with actual values
      if (params && typeof translation === "string") {
        Object.keys(params).forEach((param) => {
          translation = translation.replace(new RegExp(`{${param}}`, "g"), params[param]);
        });
      }

      return translation;
    },
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useTranslation = () => useContext(LanguageContext);
